export default "__VITE_ASSET__DRS4ESAQ__"